import { classNames, VisuallyHidden } from '@vkontakte/vkui';
import { L } from '@lang';
import { logoSizes } from './consts';
import { imageGetters } from '../../helpers';
import { DeviceType } from '../../types';
import { CrushLogo } from '../CrushLogo';
import styles from './HeaderContent.module.css';

interface HeaderContentProps {
  deviceType: DeviceType;
  navbarEnabled?: boolean;
}

export function HeaderContent(props: HeaderContentProps) {
  const { deviceType } = props;

  const headerBgImage = imageGetters.crush.headerBgImage(
    `${deviceType === 'tablet' ? 'desktop' : deviceType}_background`,
  );
  const { width, height } = logoSizes[deviceType];

  return (
    <div
      className={classNames(styles.root, styles[`root__${deviceType}`])}
      style={{ backgroundImage: `url(${headerBgImage})` }}
    >
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <CrushLogo width={width} height={height} />
          <VisuallyHidden Component="h1">{L.t('crush_landing_visually_hidden_h1')}</VisuallyHidden>
        </div>
      </div>
    </div>
  );
}
